import { createAction, props } from '@ngrx/store';

import { Tag } from '@app/tag/models/tag.model';

export const loadTags = createAction(
  '[Tags] Load tags',
  props<{ name: string }>()
);
